import type * as React from 'react';
import {
  Flex,
  Collapse,
  useDisclosure,
  IconButton,
  Box,
} from '@chakra-ui/react';
import { MobileNav } from './MobileNav';
import { headerNavItems } from './navItems';

const CloseIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

const MenuIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
);
import { DesktopNav } from './DesktopNav';

export const NavBar: React.FC = () => {
  const { isOpen, onToggle } = useDisclosure();
  return (
    <Box position="sticky" top={0} zIndex={1}>
      <Flex
        as="nav"
        boxShadow="0px 3px 6px #00000029"
        align="center"
        justifyContent="space-around"
        py="16px"
        bg="white"
      >
        <Flex display={{ lg: 'none' }}>
          <IconButton
            aria-label="Toggle navigation"
            variant="none"
            icon={isOpen ? <CloseIcon /> : <MenuIcon />}
            fontSize="40px"
            onClick={onToggle}
            _hover={{ opacity: '0.7' }}
          />
        </Flex>
        <DesktopNav />
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <MobileNav navItems={headerNavItems} />
      </Collapse>
    </Box>
  );
};
